<header class="bg-auth-100" id="header">
  <div class="h-[72px] flex items-center justify-between">
    <div class="lg:hidden flex items-center">
      <img 
        src="assets/ham.svg" 
        alt="Logo" 
        class="ham-icon w-[23px] h-[35px] mr-4 cursor-pointer" 
        (click)="toggleSidebar()"
      />
      <img src="assets/authoritie-logo.svg" class="w-[130px]" alt="Authoritie" />
    </div>
    <h1 class="font-semibold text-slate-700 max-lg:hidden text-2xl md:text-[25px]">
      {{ title$ | async }}
    </h1>

    <!-- Right Section -->
    <div class="flex items-center space-x-6">
      <!-- Notification -->
      <!-- <div class="relative">
        <button class="p-2 text-slate-400 hover:text-slate-600">
          <span
            class="absolute -top-0.5 -right-0.5 bg-red-500 text-white text-xs w-4 h-4 flex items-center justify-center rounded-full"
            >2</span
          >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
        </button>
      </div> -->

      <!-- Profile -->
      <div class="relative">
        <button
          (click)="toggleProfileMenu()"
          class="flex items-center space-x-3 hover:opacity-80 rounded-lg px-2 py-1 cursor-pointer"
          #profileButton
        >
          <img
            [src]="facebookProvider?.profile_picture_url"
            alt="Profile"
            class="w-8 h-8 rounded-full object-cover inline-block"
            [ngClass]="isRecentAdsRoute ? 'mr-10 md:mr-5' : 'mr-5'"
          />
          <span class="text-slate-600 max-md:hidden">{{ user?.name }}</span>
        </button>

        <div
          *ngIf="isProfileMenuOpen"
          [@menuAnimation]
          class="absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
        >
          <!-- <div class="px-4 py-2 border-b border-gray-100">
            <p class="text-sm font-medium text-gray-900">{{ user?.name }}</p>
            <p class="text-sm text-gray-500 truncate">{{ user?.email }}</p>
          </div> -->
          <button
            (click)="logout()"
            class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex items-center gap-2 cursor-pointer"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            Sign out
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
